import { Controller } from "@hotwired/stimulus"

// Saves a user-typed GRN on the return row without a full page visit.
export default class extends Controller {
  static targets = ["input", "button", "status"]

  async save(event) {
    event.preventDefault()
    if (this.hasButtonTarget) this.buttonTarget.disabled = true
    this.setStatus("Saving…", false)

    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        body: new FormData(this.element),
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": this.csrfToken()
        }
      })
      const data = await response.json()
      if (!response.ok || data.ok === false) {
        this.setStatus(data.message || "Could not save GRN.", true)
        return
      }
      if (this.hasInputTarget) this.inputTarget.value = data.grn || ""
      this.setStatus(data.message || "Saved", false)
    } catch (_error) {
      this.setStatus("Could not save GRN.", true)
    } finally {
      if (this.hasButtonTarget) this.buttonTarget.disabled = false
    }
  }

  setStatus(message, isError) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = message
    this.statusTarget.classList.toggle("is-error", isError)
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta ? meta.content : ""
  }
}
